<template>
  <div id="app">
    <Header routeValue="2" ref="header"></Header>
    <content class="content">
      <div class="privacy_box">
        <div class="title">Privacy Policy</div>
        <div class="time">Last modified: August 2024</div>
        <div class="row_view" style="font-family: IBM Plex Sans;">
          <p class="mb-6" style="margin:16px 0">
            <strong>Introduction</strong>
          </p>
          <p class="mb-6" style="width: 910px">
            We ("<strong><i>Printbelle</i></strong>", hereinafter referred to as "Printbelle" or
            "<strong><i>we</i></strong>") attach great importance to the protection of users' personal information
            (i.e., information that can identify users independently or in combination with other information). When you
            use the services provided by us, you agree that we collect, store, use, disclose, and protect your personal
            information in accordance with the privacy policy published on our platform. We hope to clearly introduce
            our processing of your personal information through the privacy policy. Therefore, we recommend that you
            read the privacy policy in full to help you better protect your privacy.
          </p>
          <p class="mb-6" style="margin:16px 0">
            <strong>What does this Privacy Policy cover?</strong>
          </p>
          <p class="mb-6">
            You agree to unconditionally and free of charge grant the platform the right to use non-personal information
            provided or published by you, as well as information formed during the transaction process.
          </p>
          <p class="mb-6">
            You agree that the platform has the right to send notifications about our products and services, surveys,
            promotions, and sweepstakes to you through email, SMS, phone calls, announcements, and other forms.
          </p>
          <p class="mb-6">
            We may use your personal information to prevent, detect, investigate, and address fraud, security threats,
            illegal or prohibited activities, or violations of our agreements, policies, or rules with us or our
            affiliates, to protect your, other users, or third parties legitimate rights and interests.
          </p>
          <p class="mb-6">
            Other purposes authorized by you.
          </p>
          <p class="mb-6">
            If you have any questions about this privacy policy, you can contact us through the contact information
            published on our platform. If you do not agree with any content of this privacy policy, you should
            immediately stop using our platform services. When you use any of the services provided by our platform, it
            means that you have agreed that we will legally use and protect your personal information in accordance with
            this privacy policy.
          </p>
          <p class="mb-6" style="width: 910px">
            The Platform does not provide services for minors. If it is proved that minors have registered to use our
            products and/or services without the consent of their guardians, we will immediately stop providing them
            with products or services and delete relevant personal information as soon as possible after learning about
            the situation. If you are the guardian of a minor, when you have questions about the processing of the
            personal information of a minor under your custody, or have any comments, suggestions, complaints, reports,
            you can contact us through the contact information set out in this policy, we will be ready to help you.
          </p>
          <p class="mb-6" style="margin:16px 0">
            <strong>1. What information do we collect?</strong>
          </p>
          <p class="mb-6">
            1.1 Information you provide to us:
          </p>
          <p class="mb-6">
            We receive and store any information that you knowingly provide to us. For example, when you create an
            account and place an order communication, we may collect your personal information, such as your name, email
            address, password, phone number, third-party account credentials (for example, your login credentials on
            other third-party websites), transaction information, and credit card information.
          </p>
          <p class="mb-6">
            If you provide us with a channel of communication, we may communicate with you. For example, if you provide
            us with your email address, we may send you an email informing you of your use of the Services. If you do
            not wish to receive information from us, please indicate your opt-in by choosing to use the link provided at
            the bottom of our email newsletter.
          </p>
          <p class="mb-6">
            During your use of our services, you can save your designed products. In the process of your use of the
            above functions, we will collect your saved records and other service log information for the implementation
            of the above functions and other purposes we clearly inform.
          </p>
          <p class="mb-6" style="width: 885px">
            In order to provide you with your customized goods, we will disclose your order information to the supplier
            of your choice, including the necessary information such as the type, specifications, quantity and material
            of the goods. You understand and agree that the supplier you choose will inevitably have access to your
            order information so that it can provide you with your customized goods.
          </p>
          <p class="mb-6" style="width: 898px">
            In order to help you solve the problem or record the solution and result of the relevant problem as soon as
            possible when you contact us or when you make an application for sale, after-sales or dispute settlement, we
            may save your communication, correspondence/call records and related content (including account information,
            order information, and other information you provide to prove relevant facts) with us. Or the contact
            information you left); We will use your account information and order information if you make inquiries,
            complaints or suggestions regarding a specific order. In order to provide services and improve the quality
            of the Platform services, we may also use other information about you, including the relevant information
            you provide when you contact customer service, and the questionnaire response information you send to us
            when you participate in a survey.
          </p>
          <p class="mb-6">
            1.2 Automatically Collected Information:
          </p>
          <p class="mb-6" style="width: 910px">
            If you do not refuse to use cookies, the Platform will store or access cookies on your computer so that you
            can log in to or use the Platform services or functions that rely on cookies.
          </p>
          <p class="mb-6" style="width: 900px">
            You have the option to accept or reject cookies. You can modify your acceptance of cookies or reject our
            cookies through your browser. However, if you choose not to accept cookies, you may not be able to log in to
            or use certain services or features of the Platform that rely on cookies.
          </p>
          <p class="mb-6" style="width: 900px">
            We may use this data to customize content for you that we think you might like based on your usage habits.
            We can also use it to improve our services, for example, this data can tell us how often users use a
            particular feature of the service, and we can use this knowledge to get as many users as possible interested
            in the service.
          </p>
          <p class="mb-6">
            1.3 Information collected by other websites:
          </p>
          <p class="mb-6" style="width: 900px">
            Through cookies we place on your browser or device, we may collect information about your online activities
            after you leave our website, which allows us to improve our services and customize your online experience,
            and other information described in this Privacy Policy. We use Google Analytics to collect information about
            the use of our services and websites. Google Analytics collects certain information, such as how often users
            visit this website, the pages they visit when they visit this website, and other websites they use before
            they visit this website. Google Analytics will only collect the IP address assigned to you when you visit
            the Site and will not collect your name or other personal information. Google's ability to use and share
            information collected by Google Analytics about your visit to this site is subject to the Google Analytics
            Terms of Use and the Google Privacy Policy.
          </p>
          <p class="mb-6" style="margin:16px 0">
            <strong>2. Do we share your personal information?</strong>
          </p>
          <p class="mb-6">
            We may share your personal information with third parties with your prior consent or based on your needs.
          </p>
          <p class="mb-6">
            2.1 Your personally identifiable information will not be shared:
          </p>
          <p class="mb-6" style="width: 885px">
            We may anonymize your personal information, and we will provide this information to our partners. We may
            also provide aggregate usage information to our partners, who may use this information to understand how
            often and how people use our services so that they, too, can provide you with the best online experience.
            However, we will not transfer your personal information to any company, organization or individual.
          </p>
          <p class="mb-6">
            2.2 Affiliated Enterprises:
          </p>
          <p class="mb-6" style="width: 900px">
            In some cases, the businesses or third party websites to which we belong may sell or provide products or
            services to you through or in connection with the Services (alone or in conjunction with us). We will only
            share your personal information with such affiliates in connection with such transactions or services. We
            have no control over the policies and practices of third party websites or businesses with respect to
            privacy or any other aspect, so if you choose to participate in any transaction or service related to an
            affiliated website or business, please review the policies of all such businesses or businesses.
          </p>
          <p class="mb-6" style="margin:16px 0">
            <strong>3. Is my personal information secure?</strong>
          </p>
          <p class="mb-6" style="width: 910px">
            We strive to protect the privacy of your account and other personal information in our records and maintain
            appropriate physical, technical and administrative safeguards (including encryption) to protect this
            personal information, but unfortunately we cannot guarantee complete security. Unauthorized access or use,
            hardware or software failures, and other factors can compromise the security of user information at any
            time.
          </p>
          <p class="mb-6" style="margin:16px 0">
            <strong>4. How long will my personal information be stored?</strong>
          </p>
          <p class="mb-6">
            We will keep your personal information for the duration of your account. We will retain your personal
            information for at least three years or as necessary in accordance with our legal obligations, such as the
            Electronic Commerce Law of the People's Republic of China.
          </p>
          <p class="mb-6" style="margin:16px 0">
            <strong>5. What personal information can I access?</strong>
          </p>
          <p class="mb-6">
            Through your account Settings, you can access and, in some cases, edit or delete the following information
            that you have provided to us: account, name, password, email address, or log out of your account.
          </p>
          <p class="mb-6" style="margin:16px 0">
            <strong>6. What if I have questions about this policy?</strong>
          </p>
          <p class="mb-6" style="width: 892px">
            If you have any questions or concerns about our privacy policy, please send details to our team and we will
            do our best to resolve your concerns.
          </p>
        </div>
      </div>
    </content>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from '../../components/Header.vue'
import Footer from '../../components/Footer.vue'
import {getNextMonthDate} from '@/utils/utils'

export default {
  name: 'LegalPrivacy',
  components: {
    Header,
    Footer
  },
  data () {
    return {
      currentYear: ''
    }
  },
  mounted () {
    window.scrollTo(0, 0)
    this.currentYear = getNextMonthDate(new Date().getFullYear(), new Date().getMonth() + 1)
  },
  created () {
  },
  methods: {},
}
</script>
<style scoped lang="less">

.content {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: #FFFFFF;

  .privacy_box {
    width: 924px;
    margin-top: 173px;
    margin-bottom: 76px;
    display: flex;
    flex-direction: column;
    align-items: center;

    .title {
      display: flex;
      align-items: center;
      font-weight: bold;
      font-size: 60px;
      color: #000000;
      line-height: 60px;
      font-family: IBM Plex Sans;
    }

    .time {
      display: flex;
      align-items: center;
      font-weight: 400;
      font-size: 18px;
      margin-top: 25px;
      color: #000000;
      font-family: IBM Plex Sans;
    }
  }

  .row_view {
    margin-top: 30px;

    .mb-6 {
      color: #000000;
      font-size: 16px;
      font-weight: 400;
      margin: 8px 0;

      i {
        font-family: __IBM_Plex_Sans_ce6f76, __IBM_Plex_Sans_Fallback_ce6f76;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/legal/LegalPrivacy.vue